import { Wrapper } from "./css/NavBarStyle";
import {
  FaAlignRight,
  FaUserCircle,
  FaCaretDown,
} from "react-icons/fa";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toggleSideBar, logoutUser } from "../slices/auth/authenticationSlice";
import { useMediaQuery } from "@mui/material";

import AppLogo from "./AppLogo";

const NavBar = () => {
  const [showLogout, setShowLogout] = useState(false);
  const { isSideBarOpen } = useSelector((store) => store.auth);
  const { startupData } = useSelector((store) => store.startupContents);
  const { currentUser } = useSelector((store) => store.users);
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery("(min-width: 992px)");

  const isLeftNavOpen = isDesktop ? !isSideBarOpen : isSideBarOpen;
  const shouldShowCenterTitle = !isLeftNavOpen;

  const userEmail =
    startupData?.userInfo?.email || currentUser?.email || "User";

  const toggle = () => {
    dispatch(toggleSideBar());
  };
  return (
    <Wrapper>
      <div className="nav-center">
        <button type="button" className="toggle-btn" onClick={toggle}>
          <FaAlignRight />
        </button>
        {shouldShowCenterTitle ? (
          <div>
            <AppLogo containerStyle="logo-container" textStyle="app-logo-text" />
            <h3 className="text-logo">Dashboard</h3>
          </div>
        ) : (
          <div />
        )}
        <div className="btn-container">
          <button
            type="button"
            className="btn"
            onClick={(e) => {
              e.preventDefault();
              setShowLogout(!showLogout);
            }}
          >
            <FaUserCircle />
            {userEmail}
            <FaCaretDown />
          </button>
          <div className={showLogout ? "dropdown show-dropdown" : "dropdown"}>
            <button
              type="button"
              className="dropdown-btn"
              onClick={() => {
                dispatch(logoutUser());
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
export default NavBar;
